import React, { useState } from 'react';
import { loginButton } from '../../themes/styles';
import { Field, Form, Formik } from 'formik';
import { TextField } from 'formik-material-ui';
import * as yup from 'yup';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import makeStyles from '@material-ui/core/styles/makeStyles';
import LoadingButton from '../lowLevel/LoadingButton';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import SignInGoogle from './SignInGoogle';
import TextDivider from '../BuildingBlocks/Dividers/TextDivider';
import SignUpLink from './Links/SignUpLink';
import ForgotPasswordLink from './Links/ForgotPasswordLink';
import { is8DataApp } from '../../utils';

const useStyles = makeStyles((theme: any) => ({
  fieldContainer: { padding: `${theme.spacing(1)}px 0px`, width: '100%' },
  submit: {
    ...loginButton,
    margin: '0px auto',
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  textBox: {
    backgroundColor: theme.palette.common.white,
    border: `1px solid ${theme.palette.brand.greyCyan}`,
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(0.5),
  },
  textColor: {
    color: 'black',
  },
}));

export default function SignIn({ onSubmit, error }) {
  const classes = useStyles();
  const [showPassword, setShowPassword] = useState(false);
  const shouldShowGoogleSignin = !is8DataApp();

  return (
    <Formik
      initialValues={{ email: '', password: '' }}
      validationSchema={yup.object({
        email: yup
          .string()
          .email('Invalid email')
          .required('Email is required'),
        password: yup.string().required('Password is required'),
      })}
      onSubmit={async ({ email, password }) => onSubmit(email, password)}
    >
      {({ isSubmitting }) => (
        <Form>
          <div className={classes.fieldContainer}>
            <InputLabel
              className={classes.textColor}
              shrink
              htmlFor="bootstrap-input"
            >
              Email
            </InputLabel>
            <Field
              component={TextField}
              name="email"
              type="email"
              fullWidth
              className={classes.textBox}
            />
          </div>
          <div className={classes.fieldContainer}>
            <InputLabel
              className={classes.textColor}
              shrink
              htmlFor="bootstrap-input"
            >
              Password
            </InputLabel>
            <Field
              component={TextField}
              name="password"
              type={showPassword ? 'text' : 'password'}
              className={classes.textBox}
              fullWidth
              autoComplete="on"
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="Toggle password visibility"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </div>
          <FormHelperText style={{ textAlign: 'center' }} error>
            {error}
          </FormHelperText>
          <LoadingButton
            className={classes.submit}
            type="submit"
            loading={isSubmitting}
          >
            Sign In
          </LoadingButton>
          <ForgotPasswordLink />
          {shouldShowGoogleSignin && (
            <>
              <TextDivider />
              <SignInGoogle />
            </>
          )}
          <SignUpLink />
        </Form>
      )}
    </Formik>
  );
}
